import React from "react";
import { Route,Redirect  } from "react-router-dom";
import Footer from "../layouts/UserNav/Footer";
import CrmNav from "../layouts/Crm/CrmNav";

const user = JSON.parse(localStorage.getItem("USER"))
const role = JSON.parse(localStorage.getItem("ROLE"))

const AuthRoute = ({ component: Component, ...rest }) => {
    return (
        <>
        {/* <CrmNav/> */}
        <Route {...rest} render={(props) => <Component {...props} />} />
        
        </>
    )
}

export default AuthRoute
